















import { Component, Vue } from "vue-property-decorator";
import { LANGUAGE_OPTIONS, LOCALSTORAGE_KEY } from "../../../consts/const";

@Component({})
export default class LanguageSelectBox extends Vue {
    nowLang = "";

    languageList = [
        {text:LANGUAGE_OPTIONS.JA.TEXT, value: LANGUAGE_OPTIONS.JA.VALUE},
        {text:LANGUAGE_OPTIONS.EN.TEXT, value: LANGUAGE_OPTIONS.EN.VALUE},
    ]

    created() {
      // 以前の言語の設定があればそれを設定
      /*** 2025-02-18 [MOD] EVERFOR 日本語ファイル利用固定化 (START) *+**/
      // const storedValue = this.localStorageGetItem(LOCALSTORAGE_KEY.LANG)
      const storedValue = "ja"
      /*** 2025-02-18 [MOD] EVERFOR 日本語ファイル利用固定化 ( END ) *+**/
      if (storedValue) {
        this.nowLang = storedValue;
        this.$i18n.locale = this.nowLang;
        return
      }

      // ブラウザの言語設定取得
      const browserLanguage = navigator.language;
      if (browserLanguage && browserLanguage.startsWith(LANGUAGE_OPTIONS.JA.VALUE)) {
        this.nowLang = LANGUAGE_OPTIONS.JA.VALUE;
      } else {
        this.nowLang = LANGUAGE_OPTIONS.EN.VALUE;
      }
      this.$i18n.locale = this.nowLang;
      this.localStorageSetItem(LOCALSTORAGE_KEY.LANG, this.nowLang)
    }

    onSelectLanguage(lang: string): void{
        this.$i18n.locale = lang
        this.localStorageSetItem(LOCALSTORAGE_KEY.LANG, lang)
    }

    private localStorageSetItem(key:string, value:string) {
        try {
            localStorage.setItem(key, value);
        } catch(e) {
            console.log(e);
        }
    }
    private localStorageGetItem(key: string) : string | null{
        try {
            return localStorage.getItem(key);
        } catch(e) {
            console.log(e)
            return  null;
        }
    }
}
